/**
 * 产品管理相关API接口
 */
import axios from '../axios'

const productAPI = {
  // 产品相关接口
  // 获取产品列表
  getProducts(params) {
    return axios({
      url: '/products',
      method: 'GET',
      params
    })
  },
  
  // 获取单个产品详情
  getProduct(id) {
    return axios({
      url: `/products/${id}`,
      method: 'GET'
    })
  },
  
  // 创建产品
  createProduct(data) {
    return axios({
      url: '/products',
      method: 'POST',
      data
    })
  },
  
  // 更新产品
  updateProduct(data) {
    return axios({
      url: `/products/${data.id}`,
      method: 'PUT',
      data
    })
  },
  
  // 删除产品
  deleteProduct(id) {
    return axios({
      url: `/products/${id}`,
      method: 'DELETE'
    })
  },
  
  // 更新产品状态
  updateProductStatus(id, status) {
    return axios({
      url: `/products/${id}/status`,
      method: 'PATCH',
      data: { status }
    })
  },
  
  // 获取产品下属模板
  getTemplatesByProductId(productId) {
    return axios({
      url: `/products/${productId}/templates`,
      method: 'GET'
    })
  },
  
  // 创建产品下属模板
  createTemplate(productId, data) {
    return axios({
      url: `/products/${productId}/templates`,
      method: 'POST',
      data
    })
  },
  
  // 删除模板
  deleteContainer(templateId) {
    return axios({
      url: `/templates/${templateId}`,
      method: 'DELETE'
    })
  },
  
  // 更新模板
  updateContainer(templateId, data) {
    return axios({
      url: `/templates/${templateId}`,
      method: 'PUT',
      data
    })
  },
  // 新增模板内容
  addContents(templateId) {
    return axios({
      url: `/templates/${templateId}/contents`,
      method: 'PUT'
    })
  },
  // 新增模板标签内容
  addTabsContents(templateId, data) {
    return axios({
      url: `/templates/${templateId}/tabs/contents`,
      method: 'PUT',
      data
    })
  }
}

export default productAPI